import {TargetBlank} from '@wandb/weave/common/util/links';
// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import React from 'react';

import {useViewer} from '../../../state/viewer/hooks';
import DocUrls from '../../../util/doc_urls';
import {Quickstart} from './Quickstart';
import * as S from './ZeroQueues.styles';

type ZeroQueuesProps = {
  onCreateQueue: () => void;
};

export const ZeroQueues = ({onCreateQueue}: ZeroQueuesProps) => {
  const viewer = useViewer();
  const isLoggedIn = !!viewer;
  return (
    <S.Page>
      <S.ColumnSpacer />
      <S.PanelRow>
        <S.PanelColumn>
          <S.Heading>
            Start launching jobs into any target environment.
          </S.Heading>
          <S.Message>
            W&B Launch takes care of packaging your code and dependencies so all
            you need to do is decide where to run it.
            <br></br>
            <br></br>
            Create your first queue to get started.
          </S.Message>
          <div>
            <TargetBlank href={DocUrls.launch}>
              <Button
                size="large"
                variant="secondary"
                icon="documentation"
                style={{marginRight: '8px'}}>
                Documentation
              </Button>
            </TargetBlank>
            {isLoggedIn && (
              <Button
                data-test="create-queue"
                className="create-collection"
                icon="add-new"
                size="large"
                onClick={onCreateQueue}>
                Create a queue
              </Button>
            )}
          </div>
        </S.PanelColumn>
        <Quickstart />
      </S.PanelRow>
    </S.Page>
  );
};
